import { Download } from "@/services/admin-services/models";
import { Version } from "@/services/global-services/models";

interface StaticFile {
    name: string;
    contentLength: number;
    version: string;
    languageCode?: string;
}

const baseUrl = "https://stidsplatformprod.blob.core.windows.net/assets/Uploads/";
const staticFiles: Array<StaticFile> = [
    {
        name: "Guide-BIM-Luxembourg_EIR-FichesGID__v1-0.xlsx",
        contentLength: 15558581,
        version: "1.0",
    },
    {
        name: "Guide-BIM-Luxembourg_EIR-FichesGID__v1-1.xlsx",
        contentLength: 15565387,
        version: "1.1",
    },
    {
        name: "Guide-BIM-Luxembourg_EIR-FichesGID__v1-2.1.xlsx",
        contentLength: 5437562,
        version: "1.2.1",
    },
    {
        name: "Guide-BIM-Luxembourg_EIR-FichesGID__v1-2.3.xlsx",
        contentLength: 5418558,
        version: "1.2.3",
    },
    {
        name: "Guide-BIM-Luxembourg_EIR-FichesGID__v1-2.xlsx",
        contentLength: 5415328,
        version: "1.2",
    },
];

export const getStaticDownloads = (): Array<Download> => {
    const downloads: Array<Download> = [];

    for (let i = 0; i < staticFiles.length; i++) {
        const file = staticFiles[i];

        const download: Download = {
            id: `manual_upload_${i + 1}`,
            name: file.name,
            disciplines: [],
            software: ["00000000-0000-0000-0000-000000000000"],
            useCases: [],
            extension: "xlsx",
            language: "Français",
            languageCode: file.languageCode ?? "int-fr",
            location: baseUrl + file.name,
            uploadDate: new Date().toLocaleDateString(),
            versions: file.version,
            size: file.contentLength,
        };

        downloads.push(download);
    }

    return downloads;
};

export const getStaticVersions = (): Array<Version> => {
    const versions: Array<Version> = [];

    for (let i = 0; i < staticFiles.length; i++) {
        const file = staticFiles[i];

        let modifier = 0;
        const versionParts = file.version.split(".");
        modifier += parseInt(versionParts[0]) * 100;
        modifier += parseInt(versionParts[1]) * 10;
        if (versionParts.length > 2) modifier += parseInt(versionParts[2]);

        if (versions.some((v) => v.name === file.version)) continue;

        versions.push({
            id: `static_version_${i + 1}`,
            isDefault: false,
            name: file.version,
            publicationDate: new Date(1000 + modifier, 1, 1),
        });
    }

    return versions;
};
